"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowRadioEdit_1 = require("../../components/editors/CardRowRadioEdit");
var TextArea = antd_1.Input.TextArea;
var DlgExportList = /** @class */ (function (_super) {
    __extends(DlgExportList, _super);
    function DlgExportList(props) {
        return _super.call(this, props) || this;
    }
    DlgExportList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.dialogTitle,
                exportFormatCode: data.exportFormatCode
            });
        });
        this.setState({
            visible: false,
            dialogTitle: "",
            exportFormatCode: "XLSX"
        });
    };
    DlgExportList.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgExportList.prototype.handleYes = function () {
        this.props.controller.Close();
        if (this.props.controller.DATA.onYes) {
            this.props.controller.DATA.onYes(this.state.exportFormatCode);
        }
    };
    DlgExportList.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgExportList.prototype.render = function () {
        var _this = this;
        return (React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: true, maskClosable: false, okType: "primary", style: { minWidth: 500 } },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" } },
                React.createElement("div", { style: { width: "100%", textAlign: "left", fontWeight: "bold", margin: 5, marginLeft: 0 } }, "\u0424\u043E\u0440\u043C\u0430\u0442 \u044D\u043A\u0441\u043F\u043E\u0440\u0442\u0430"),
                React.createElement(CardRowRadioEdit_1.default, { items: [{ key: "JSON", title: "JSON" }, { key: "TXT", title: "TXT" }, { key: "CSV", title: "CSV" }, { key: "XLSX", title: "XLSX" }], value: this.state.exportFormatCode, onValueChanged: function (newVal) { _this.setState({ exportFormatCode: newVal }); }, title: "Выберите формат: " }))));
    };
    return DlgExportList;
}(React.Component));
exports.default = DlgExportList;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ui/DlgExportList.tsx
// module id = 2533
// module chunks = 0